import React, { Fragment } from "react"
import { Minus, Plus, X as CloseIcon } from 'phosphor-react';
import { translate } from "../Services/translation";

export default props => {
    const { product, decreaseQuantity, increaseQuantity, deleteRow } = props
    const { voucherCode, isPreOrder, preOrderInfoText, image, brand, name, styleName, campaignPercentage, campaignPrice, price, quantityString, properties} = product
    return <div className="cart-container__item">
        <a className="cart-container__image-url" href={product.url}>
            <img src={image} />
        </a>
        <div className="cart-container__item-details">
            <CloseIcon size="12" className="cart-container__item-delete" onClick={deleteRow}/>
            <div className="cart-container__item-brand"><a href={product.url}>{brand}</a></div>
            <div className="cart-container__item-name"><a href={product.url}>{styleName || name}</a></div>
            <div className="cart-container__item-properties">
                {properties.map((value, idx) => <Fragment key={idx}>{value} {properties[idx+1] ? <span className="cart-container__item-properties-divider"></span> : null}</Fragment>)}
            </div>
            {isPreOrder && <div className="cart-container__item-preorder product__tags">
                <span>{translate("product.preorder")}</span>
                <p>{preOrderInfoText}</p>
            </div>}
            <div className="cart-container__item-footer">
                {campaignPrice && <div className="cart-container__campaign-price">
                    <span className="cart-container__item-price">{campaignPrice}</span>
                    <span className="cart-container__item-price-old">{price}</span>
                    <span className="cart-container__item-campaign-percentage">{campaignPercentage}</span>
                </div>}
                {!campaignPrice && <div className="cart-container__item-price">{price}</div>}
                <div className="cart-container__item-quantity-input">
                    <Minus size="12" color="#757575" onClick={decreaseQuantity} />
                    <span className="cart-container__item-quantity-input-value no-select">{quantityString}</span>
                    <Plus size="12" color="#757575" onClick={increaseQuantity} />
                </div>
            </div>
            {voucherCode && voucherCode.discountPercent && voucherCode.code &&
                <div class="product__usps">
                    <span class="product__usps--discount">{translate("product.voucher-code").replace("{0}", voucherCode.discountPercent)}&nbsp;<span class="product__usps--discount--amount">{voucherCode.code.toUpperCase()}</span></span>
                </div>
            }
        </div>
    </div>
}